/**
 * 三段式接入 — 平台预设 / 弹窗选项唯一配置源
 * 修改默认 TTS 引擎、系统 LLM、各端「添加资源/模型」供应商列表只改本文件
 */

const LLM_SYSTEM_MODEL_CATALOG_ITEMS = [
  {
    id: 'qwen3.6-flash',
    label: '级联语音大模型-G1',
  },
]

const LLM_DEFAULT_SYSTEM_MODEL_ID = 'qwen3.6-flash'

const LLM_RESOURCE_PROVIDER_LIST = [
  '阿里云通义千问 QWen',
  // 'OpenAI',
  // 'DeepSeek',
  // 'Minimax',
]

function buildLlmProviderDefaultModelIdMap(providers, defaultModelId) {
  return Object.freeze(
    providers.reduce((acc, provider) => {
      acc[provider] = defaultModelId
      return acc
    }, {}),
  )
}

export const TRIPLE_ACCESS_PLATFORM_DEFAULTS = Object.freeze({
  tts: Object.freeze({
    /** dictionary/tts 默认 engineName */
    defaultEngine: 'cosyvoice3.5-aliyun',
    /** 添加 TTS 资源弹窗 — 供应商 */
    resourceProviders: Object.freeze(['Minimax', '豆包', '阿里云', '讯飞']),
  }),
  asr: Object.freeze({
    /** 添加 ASR 资源弹窗 — 供应商 */
    resourceProviders: Object.freeze(['腾讯', '阿里云', '讯飞', 'Minimax']),
  }),
  llm: Object.freeze({
    /** 添加 LLM 模型弹窗 — 供应商 */
    resourceProviders: Object.freeze(LLM_RESOURCE_PROVIDER_LIST),
    /** triple_access.llm.resource 系统资源前缀：`system:{modelId}` */
    systemResourcePrefix: 'system:',
    /** 系统预设 LLM（资源下拉）；id = API model 字段 */
    systemModelCatalog: Object.freeze(LLM_SYSTEM_MODEL_CATALOG_ITEMS.map((item) => Object.freeze({ ...item }))),
    /** 默认系统 LLM model id（须存在于 systemModelCatalog） */
    defaultSystemModelId: LLM_DEFAULT_SYSTEM_MODEL_ID,
    /** 添加模型弹窗 — 供应商未填 model 时的默认 model id */
    providerDefaultModelId: buildLlmProviderDefaultModelIdMap(
      LLM_RESOURCE_PROVIDER_LIST,
      LLM_DEFAULT_SYSTEM_MODEL_ID,
    ),
  }),
})

export default TRIPLE_ACCESS_PLATFORM_DEFAULTS
